export default __webpack_public_path__ + "static/media/Research2.094907b8.jpg";